export default function () {
  return [
    {
      type: 'DatePicker',
      title: '年度',
      [$field]: 'year',
      readOnly: true,
      props: {
        type: 'year'
      },
      rules: []
    },
    {
      type: 'DatePicker',
      title: '下发时间',
      readOnly: true,
      [$field]: 'startDate'
    },
    {
      type: 'DatePicker',
      title: '签发时限日期',
      readOnly: true,
      [$field]: 'endDate'
    },
    {
      title: '签署说明',
      type: 'textarea',
      readOnly: true,
      colSpan: 24,
      props: {
        maxlength: 500
      },
      [$field]: 'reportDesc'
    }
  ]
}